export const TIER_LIST = [
    { value: 'Tier 1A', displayText: 'Tier 1A' },
    { value: 'Tier 1B', displayText: 'Tier 1B' },
    { value: 'Tier 2', displayText: 'Tier 2' },
    { value: 'Tier 3', displayText: 'Tier 3' },
];